/*import logo from './logo.svg';
import './App.css';

function App() {
  return (
    <div className="App">
      <header className="App-header">
        <img src={logo} className="App-logo" alt="logo" />
        <p>
          Edit <code>src/App.js</code> and save to reload.
        </p>
        <a
          className="App-link"
          href="https://reactjs.org"
          target="_blank"
          rel="noopener noreferrer"
        >
          Learn React
        </a>
      </header>
    </div>
  );
}

export default App;*/
// TODO: Import React module
import * as React from 'react';
import { BrowserRouter as Router, Routes, Route } from 'react-router-dom'

// TODO: Import MUI module
import { } from '@mui/material';
import CssBaseline from "@mui/material/CssBaseline";
import { ThemeProvider } from '@mui/material/styles';

// TODO: Import MUI icon

// TODO: Import context

// TODO: Import custom component
import Home from './Home/Home';
//import HomeHarmoniousCampusPolicy from './Home/�M�Ӯն�F��(�Ը߽Z)';
import PrivacyPolicyOfMyTYH from './Home/PrivacyPolicyOfMyTYH';
import DSEOutstandingStudentVisit from './DSEOutstandingStudentVisit/DSEOutstandingStudentVisit';

import ACHAwardsExternal from './Achievements/AwardsExternal';
import ACHMediaPressCoverage from './Achievements/MediaPressCoverage';
import ACHDSEResult2026 from './Achievements/DSEResult2026';

import ACTExchangeTour from './Activities/ExchangeTour';
import ACTHappyFriday from './Activities/HappyFriday';
import ACTLifeWideLearning from './Activities/LifeWideLearning';
import ACTMusic from './Activities/Music';
import ACTPE from './Activities/PE';
import ACTVA from './Activities/VA';

import ADMCharacteristics from './Admission/Characteristics';
import ADMS1Admission from './Admission/S1Admission';
import ADMS1Application from './Admission/S1Application';
import ADMS1Registration from './Admission/S1Registration';
import ADMTransferStudents from './Admission/TransferStudents';

import Album from './Album/Album';

import Alumni from './Alumni/Alumni';

import CDACE from './CampusDevelopment/ACE';
import CDBlessedBotanicals from './CampusDevelopment/BlessedBotanicals';
import CDCafeGeographie from './CampusDevelopment/CafeGeographie';
import CDCarbonFootprint from './CampusDevelopment/CarbonFootprint';
import CDEnvironmental from './CampusDevelopment/Environmental';
import CDIT from './CampusDevelopment/IT';
import CDLanTingJu from './CampusDevelopment/LanTingJu';
import CDMusicRoom from './CampusDevelopment/MusicRoom';
import CDSolarPhotovoltaicSystems from './CampusDevelopment/SolarPhotovoltaicSystems';

import CDCafeOrder from './CampusDevelopment/CafeOrder/CafeOrder';
import CDCafeOrderStaff from './CampusDevelopment/CafeOrder/CafeOrderStaff';
import CDCafeOrderDisplay from './CampusDevelopment/CafeOrder/CafeOrderDisplay';

import InfoDay from './InfoDay/InfoDay';

import LTAppliedLearning from './LearningAndTeacher/AppliedLearning';
import LTCurriculum from './LearningAndTeacher/Curriculum';
import LTElectiveSubjectIntro from './LearningAndTeacher/ElectiveSubjectIntro';
import LTEnglishEducationEnglishLearning from './LearningAndTeacher/EnglishEducation/EnglishLearning';
import LTEnglishEducationEnglishCorner from './LearningAndTeacher/EnglishEducation/EnglishCorner';
import LTEnglishEducationInternalActivities from './LearningAndTeacher/EnglishEducation/InternalActivities';
import LTEnglishEducationTraining from './LearningAndTeacher/EnglishEducation/Training';
import LTEnglishEducationSchemes from './LearningAndTeacher/EnglishEducation/Schemes';
import LTEnglishEducationExternalActivities from './LearningAndTeacher/EnglishEducation/ExternalActivities';
import LTEnglishEducationMeet from './LearningAndTeacher/EnglishEducation/Meet';
import LTGiftedEducation from './LearningAndTeacher/GiftedEducation';
import LTLearningSupportProgramme from './LearningAndTeacher/LearningSupportProgramme';
import LTPromotionReading from './LearningAndTeacher/PromotionReading';
import LTSubjectsDSE from './LearningAndTeacher/SubjectsDSE';
import LTSTEAMEducation from './LearningAndTeacher/STEAMEducation';
import LTS1StudyTips from './LearningAndTeacher/S1StudyTips';

import MusicalWork from './MusicalWork/MusicalWork';
import MusicalWorkActivitiesContent from './MusicalWork/ActivitiesContent';

import MusicContest from './MusicContest/MusicContest';

import News from './News/News';

import P202501240736 from './Pages/P202501240736';
import P202502111110 from './Pages/P202502111110';
import P202505191128 from './Pages/P202505191128';

import PTA from './PTA/PTA';

import Recruit from './Recruit/Recruit';

import SchoolProfileExternalSchoolReview from './SchoolProfile/ExternalSchoolReview';
import SchoolProfileSchoolCalendar from './SchoolProfile/SchoolCalendar';
import SchoolProfileMissionVision from './SchoolProfile/MissionVision';
import SchoolProfileMottoSchoolSong from './SchoolProfile/MottoSchoolSong';
import SchoolProfilePolicy from './SchoolProfile/Policy';
import SchoolProfilePrincipalsWords from './SchoolProfile/PrincipalsWords';
import SchoolProfileSchoolPlansReports2021 from './SchoolProfile/SchoolPlansReports2021';
import SchoolProfileSchoolPlansReports2022 from './SchoolProfile/SchoolPlansReports2022';
import SchoolProfileSchoolPlansReports2023 from './SchoolProfile/SchoolPlansReports2023';
import SchoolProfileSchoolPlansReports2024 from './SchoolProfile/SchoolPlansReports2024';
import SchoolProfileSchoolPlansReports2025 from './SchoolProfile/SchoolPlansReports2025';
import SchoolProfileSchoolProfile from './SchoolProfile/SchoolProfile';

import SDClassBuilding from './StudentDevelopment/ClassBuilding';
import SDDisciplineCounselling from './StudentDevelopment/DisciplineCounselling';
import SDHouses from './StudentDevelopment/Houses';
import SDIE from './StudentDevelopment/IE';
import SDLifePlanning from './StudentDevelopment/LifePlanning';
import SDMoralCivicNationalEducation from './StudentDevelopment/MoralCivicNationalEducation';
import SDSocialServicesCommittee from './StudentDevelopment/SocialServicesCommittee';
import SDUniformedGroups from './StudentDevelopment/UniformedGroups';
import SDStudentLeadership from './StudentDevelopment/StudentLeadership';
import SDStudentsUnion from './StudentDevelopment/StudentsUnion';

import UniPass from './UniPass/UniPass';
import UniPassParent from './UniPassParent/UniPassParent';

import VAWork from './VAWork/VAWork';

import { ContextProvider } from './Common/Context';
import { ThemeTYH } from './Common/Theme';

export default function TYH() {
    // TODO: Define useContext

    // TODO: Define variable

    // TODO: Define event

    // TODO: Define function

    // TODO: Return component
    //const basename = window.location.hostname === 'www.pohtyh.edu.hk' ? '/' : '/';

    return (
        <ThemeProvider theme={ThemeTYH}>
            <CssBaseline />
            <ContextProvider>
                <Router>
                    <Routes>
                        <Route element={<Home />} index path="/" />
                        <Route element={<Home />} path="*" />
                        <Route element={<PrivacyPolicyOfMyTYH />} path="/PrivacyPolicyOfMyTYH" />
                        <Route element={<DSEOutstandingStudentVisit />} path="/DSEOutstandingStudentVisit" />

                        <Route element={<ACHAwardsExternal />} path="/ACH_AwardsExternal" />
                        <Route element={<ACHDSEResult2026 />} path="/ACH_DSEResult2026" />
                        <Route element={<ACHMediaPressCoverage />} path="/ACH_MediaPressCoverage" />
                        <Route element={<ACTExchangeTour />} path="/ACT_ExchangeTour" />
                        <Route element={<ACTHappyFriday />} path="/ACT_HappyFriday" />
                        <Route element={<ACTLifeWideLearning />} path="/ACT_LifeWideLearning" />
                        <Route element={<ACTMusic />} path="/ACT_Music" />
                        <Route element={<ACTPE />} path="/ACT_PE" />
                        <Route element={<ACTVA />} path="/ACT_VA" />
                        <Route element={<ADMCharacteristics />} path="/ADM_Characteristics" />
                        <Route element={<ADMS1Admission />} path="/ADM_S1Admission" />
                        <Route element={<ADMS1Application />} path="/ADM_S1Application" />
                        <Route element={<ADMS1Registration />} path="/ADM_S1Registration" />
                        <Route element={<ADMTransferStudents />} path="/ADM_TransferStudents" />
                        <Route element={<Album />} path="/Album" />
                        <Route element={<Alumni />} path="/Alumni" />
                        <Route element={<CDACE />} path="/CD_ACE" />
                        <Route element={<CDBlessedBotanicals />} path="/CD_BlessedBotanicals" />
                        <Route element={<CDCafeGeographie />} path="/CD_CafeGeographie" />
                        <Route element={<CDCafeOrder />} path="/CD_CafeOrder" />
                        <Route element={<CDCafeOrderStaff />} path="/CD_CafeOrderStaff" />
                        <Route element={<CDCafeOrderDisplay />} path="/CD_CafeOrderDisplay" />
                        <Route element={<CDCarbonFootprint />} path="/CD_CarbonFootprint" />
                        <Route element={<CDEnvironmental />} path="/CD_Environmental" />
                        <Route element={<CDIT />} path="/CD_IT" />
                        <Route element={<CDLanTingJu />} path="/CD_LanTingJu" />
                        <Route element={<CDMusicRoom />} path="/CD_MusicRoom" />
                        <Route element={<CDSolarPhotovoltaicSystems />} path="/CD_SolarPhotovoltaicSystems" />
                        <Route element={<InfoDay />} path="/InfoDay" />
                        <Route element={<LTAppliedLearning />} path="/LT_AppliedLearning" />
                        <Route element={<LTCurriculum />} path="/LT_Curriculum" />
                        <Route element={<LTElectiveSubjectIntro />} path="/LT_ElectiveSubjectIntro" />
                        <Route element={<LTEnglishEducationEnglishLearning />} path="/LT_E_EnglishLearning" />
                        <Route element={<LTEnglishEducationEnglishCorner />} path="/LT_E_EnglishCorner" />
                        <Route element={<LTEnglishEducationInternalActivities />} path="/LT_E_InternalActivities" />
                        <Route element={<LTEnglishEducationTraining />} path="/LT_E_Training" />
                        <Route element={<LTEnglishEducationSchemes />} path="/LT_E_Schemes" />
                        <Route element={<LTEnglishEducationExternalActivities />} path="/LT_E_ExternalActivities" />
                        <Route element={<LTEnglishEducationMeet />} path="/LT_E_Meet" />
                        <Route element={<LTGiftedEducation />} path="/LT_GiftedEducation" />
                        <Route element={<LTLearningSupportProgramme />} path="/LT_LearningSupportProgramme" />
                        <Route element={<LTPromotionReading />} path="/LT_PromotionReading" />
                        <Route element={<LTSubjectsDSE />} path="/LT_SubjectsDSE" />
                        <Route element={<LTSTEAMEducation />} path="/LT_STEAMEducation" />
                        <Route element={<LTS1StudyTips />} path="/LT_S1StudyTips" />
                        <Route element={<MusicalWork />} path="/MusicalWork" />
                        <Route element={<MusicalWorkActivitiesContent />} path="/MusicalWorkActivitiesContent" />
                        <Route element={<MusicContest />} path="/MusicContest" />
                        <Route element={<News />} path="/News" />
                        <Route element={<P202501240736 />} path="/P202501240736" />
                        <Route element={<P202502111110 />} path="/P202502111110_ChoralSpeakingChampions" />
                        <Route element={<P202505191128 />} path="/P202505191128" />
                        <Route element={<PTA />} path="/PTA" />
                        <Route element={<Recruit />} path="/Recruit" />
                        <Route element={<SchoolProfileExternalSchoolReview />} path="/SchoolProfile_ExternalSchoolReview" />
                        <Route element={<SchoolProfileSchoolCalendar />} path="/SchoolProfile_SchoolCalendar" />
                        <Route element={<SchoolProfileMissionVision />} path="/SchoolProfile_MissionVision" />
                        <Route element={<SchoolProfileMottoSchoolSong />} path="/SchoolProfile_MottoSchoolSong" />
                        <Route element={<SchoolProfilePolicy />} path="/SchoolProfile_Policy" />
                        <Route element={<SchoolProfilePrincipalsWords />} path="/SchoolProfile_PrincipalsWords" />
                        <Route element={<SchoolProfileSchoolPlansReports2021 />} path="/SchoolProfile_SchoolPlansReports2021" />
                        <Route element={<SchoolProfileSchoolPlansReports2022 />} path="/SchoolProfile_SchoolPlansReports2022" />
                        <Route element={<SchoolProfileSchoolPlansReports2023 />} path="/SchoolProfile_SchoolPlansReports2023" />
                        <Route element={<SchoolProfileSchoolPlansReports2024 />} path="/SchoolProfile_SchoolPlansReports2024" />
                        <Route element={<SchoolProfileSchoolPlansReports2025 />} path="/SchoolProfile_SchoolPlansReports2025" />
                        <Route element={<SchoolProfileSchoolProfile />} path="/SchoolProfile_SchoolProfile" />
                        <Route element={<SDClassBuilding />} path="/SD_ClassBuilding" />
                        <Route element={<SDDisciplineCounselling />} path="/SD_DisciplineCounselling" />
                        <Route element={<SDHouses />} path="/SD_Houses" />
                        <Route element={<SDIE />} path="/SD_IE" />
                        <Route element={<SDLifePlanning />} path="/SD_LifePlanning" />
                        <Route element={<SDMoralCivicNationalEducation />} path="/SD_MoralCivicNationalEducation" />
                        <Route element={<SDSocialServicesCommittee />} path="/SD_SocialServicesCommittee" />
                        <Route element={<SDStudentLeadership />} path="/SD_StudentLeadership" />
                        <Route element={<SDStudentsUnion />} path="/SD_StudentsUnion" />
                        <Route element={<SDUniformedGroups />} path="/SD_UniformedGroups" />
                        <Route element={<UniPass />} path="/UniPass" />
                        <Route element={<UniPassParent />} path="/UniPassParent" />
                        <Route element={<VAWork />} path="/VAWork" />
                    </Routes>
                </Router>
            </ContextProvider>
        </ThemeProvider>
    );
}
